import { Component, Input } from '@angular/core';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';

@Component({
  selector: 'lp2-videos-tile',
  templateUrl: './videos-tile.component.html',
  styleUrls: ['./videos-tile.component.scss'],
})
export class VideosTileComponent {
  @Input() video: StudyBundleCourseDto = <StudyBundleCourseDto>{};
  @Input() loading: boolean;

  constructor() {}
}



// WEBPACK FOOTER //
// ./ts/app/home/videos-tile/videos-tile.component.ts